import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Custom hook to get feedback-specific CSS configuration
 */
export const useFeedbackCss = () => {
  const { css } = useSelector((s) => s.widgetSettings);

  const feedbackCss = useMemo(
    () => css?.find((i) => i?.cssTabFieldsGroupName === "Feedback")?.fields,
    [css]
  );

  return feedbackCss;
};
